// extracted by mini-css-extract-plugin
export default {"durationVarianceCell":"DurationVarianceCell_durationVarianceCell__lv4fB","title":"DurationVarianceCell_title__jkQVd"};